import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/utils/Tag.ts

var Tag_exports = {};

__export(Tag_exports, {
  authedLinkPattern: function authedLinkPattern() {
    return _authedLinkPattern;
  },
  handleAddTagMemberText: function handleAddTagMemberText() {
    return _handleAddTagMemberText;
  },
  handleGetMatchParts: function handleGetMatchParts() {
    return _handleGetMatchParts;
  },
  handleReplaceText: function handleReplaceText() {
    return _handleReplaceText;
  },
  linkMatch: function linkMatch() {
    return _linkMatch;
  },
  linkPattern: function linkPattern() {
    return _linkPattern;
  },
  renderTagMemberText: function renderTagMemberText() {
    return _renderTagMemberText;
  },
  searchTagMemberText: function searchTagMemberText() {
    return _searchTagMemberText;
  },
  tagPattern: function tagPattern() {
    return _tagPattern;
  }
});

import _ from "lodash";
import * as R from "ramda";
var _tagPattern = /@\[(.*?)]\(([^)]*)\)/;
var _authedLinkPattern = /https:\/\/hi(-staging)?.h2health.cn[^\s]*/i;
var linkPatternString = "https?://(www.)?[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)";

var _linkPattern = new RegExp(linkPatternString, "i");

var _linkMatch = new RegExp(linkPatternString, "gi");

var _renderTagMemberText = function _renderTagMemberText(text, matches) {
  return "@".concat(matches[2]);
};

var _handleAddTagMemberText = function _handleAddTagMemberText(_ref) {
  var _member, _member2, _member3;

  var _ref$text = _ref.text,
      text = _ref$text === void 0 ? "" : _ref$text,
      _ref$tagMembers = _ref.tagMembers,
      tagMembers = _ref$tagMembers === void 0 ? [] : _ref$tagMembers,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? text.length : _ref$cursor;
  if (!cursor || !tagMembers.length) return text;
  var tagMembersObject = R.indexBy(R.prop("nick_name"), tagMembers);
  var tagMembersEntries = Object.entries(tagMembersObject);
  var tagMembersMap = new Map(tagMembersEntries);

  var _searchTagMemberText2 = _searchTagMemberText(cursor, text),
      _searchTagMemberText3 = _slicedToArray(_searchTagMemberText2, 2),
      found = _searchTagMemberText3[0],
      _searchTagMemberText4 = _slicedToArray(_searchTagMemberText3[1], 2),
      l = _searchTagMemberText4[0],
      r = _searchTagMemberText4[1];

  if (!found) return text;
  var member = tagMembersMap.get(found.substring(1));

  while (found && !member && cursor-- > l) {
    var _searchTagMemberText5 = _searchTagMemberText(cursor, text),
        _searchTagMemberText6 = _slicedToArray(_searchTagMemberText5, 2),
        _found = _searchTagMemberText6[0],
        _searchTagMemberText7 = _slicedToArray(_searchTagMemberText6[1], 2),
        _l = _searchTagMemberText7[0],
        _r = _searchTagMemberText7[1];

    member = tagMembersMap.get(_found === null || _found === void 0 ? void 0 : _found.substring(1));

    if (member) {
      found = _found;
      l = _l;
      r = _r;
    }
  }

  var tagSnippet = member ? "@[id=".concat((_member = member) === null || _member === void 0 ? void 0 : _member.id, "&type=").concat((_member2 = member) === null || _member2 === void 0 ? void 0 : _member2.class_name, "](").concat((_member3 = member) === null || _member3 === void 0 ? void 0 : _member3.nick_name, ")") : found;
  return _handleAddTagMemberText({
    text: text.substring(0, l),
    tagMembers: tagMembers
  }) + tagSnippet + _handleAddTagMemberText({
    text: text.substring(r),
    tagMembers: tagMembers
  });
};

var _searchTagMemberText = function _searchTagMemberText(index, text) {
  var l = index - 1;

  while (l > -1) {
    var lc = text[l];

    if (lc === "@") {
      var r = index;

      while (r < text.length) {
        var rc = text[r];

        if (rc === "@" || rc === "\u3001" || rc.match(/\s/)) {
          return [text.slice(l, r), [l, r]];
        }

        ++r;
      }

      return [text.slice(l, r), [l, r]];
    }

    --l;
  }

  return [null, []];
};

var _handleGetMatchParts = function _handleGetMatchParts(_ref2) {
  var text = _ref2.text,
      pattern = _ref2.pattern;
  var matchParts = [];
  var textLeft = text;

  while (textLeft) {
    var matches = pattern.exec(textLeft);

    if (!matches) {
      break;
    }

    matchParts.push(matches);
    textLeft = textLeft.substr(matches.index + matches[0].length);
  }

  return matchParts;
};

var _handleReplaceText = function _handleReplaceText(_ref3) {
  var text = _ref3.text,
      pattern = _ref3.pattern,
      renderText = _ref3.renderText;

  var matchParts = _handleGetMatchParts({
    text: text,
    pattern: pattern
  });

  var replaceText = text;

  _.forEach(matchParts, function (matches) {
    replaceText = _.replace(replaceText, matches[0], renderText(text, matches));
  });

  return replaceText;
};

export { _tagPattern as tagPattern, _authedLinkPattern as authedLinkPattern, _linkPattern as linkPattern, _linkMatch as linkMatch, _renderTagMemberText as renderTagMemberText, _handleAddTagMemberText as handleAddTagMemberText, _searchTagMemberText as searchTagMemberText, _handleGetMatchParts as handleGetMatchParts, _handleReplaceText as handleReplaceText, Tag_exports };